import { useEffect, useState } from "react";
import { CircularProgress, Stack, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { CurrencyExchangeRateTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";
import DeleteIcon from '@mui/icons-material/Delete';
import { computeExchangeAmountService } from "../../../utils/api/configuration/currencyexchangerate/computeAmount";
import Cookies from "universal-cookie";

export const CurrencyExchangeRateTable: React.FC<CurrencyExchangeRateTablePropsType> = ({ rows, handleItemClick, selectedCurrencyExchangeRateId }) => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const currencyExchangeRateTableHeaders = ["Currency Pair", "Buy/Sell", "Display Amount", "Action"];
    // Change to an object to store computed amounts for each row by ID
    const [computedAmounts, setComputedAmounts] = useState<Record<string, number>>({});

    useEffect(() => {
        // Skip if no rows or no token
        if (!rows?.length || !TOKEN) return;
        const fetchComputedAmounts = async () => {
            // Process each row to get its computed amount
            const amounts: Record<string, number> = {};
            for (const row of rows) {
                try {
                    if (row.from && row.to && row.spread) {
                        const response = await computeExchangeAmountService(
                            TOKEN,
                            1,
                            row.from,
                            row.to,
                            row.spread
                        );
                        amounts[row.id] = response.computedAmount;
                    }
                } catch (error) {
                    console.error(`API fetch error for row ${row.id}:`, error);
                    amounts[row.id] = 0;
                }
            }
            setComputedAmounts(amounts);
        };

        fetchComputedAmounts();
    }, [TOKEN, rows]);

    return (
        <BaseTable headers={currencyExchangeRateTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{`${row?.from} → ${row?.to}`}</TableCell>
                            <TableCell>{row?.option.charAt(0).toUpperCase() + row?.option.slice(1)}</TableCell>
                            <TableCell>
                                {computedAmounts[row.id] !== undefined
                                    ? computedAmounts[row.id]
                                    : <CircularProgress color="inherit" className="loader" />}
                            </TableCell>
                            <TableCell>
                                <Stack direction="row" gap="calc(var(--flex-gap)/4)">
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick(e, row.id, "edit")}
                                    >
                                        Edit
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick?.(e, { currencyExchangeRateId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {selectedCurrencyExchangeRateId !== null && selectedCurrencyExchangeRateId === row.id ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}